import { render, staticRenderFns } from "./HospitalIntroZjyy.vue?vue&type=template&id=c75e90ba&scoped=true"
import script from "./HospitalIntroZjyy.vue?vue&type=script&lang=js"
export * from "./HospitalIntroZjyy.vue?vue&type=script&lang=js"
import style0 from "./HospitalIntroZjyy.vue?vue&type=style&index=0&id=c75e90ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75e90ba",
  null
  
)

export default component.exports